import React, {Fragment} from "react"
import { Link } from "react-router-dom"

const BlockStyleEight = () => {
    return (
        <Fragment>
            <div className="block-style-eight mb-45 ps-xxl-5" data-aos="fade-up">
                <h6 className="sub-title-two mb-20">Sistema de Huellas Dactilares</h6>
                <h3 className="sect-title mb-25">Hacemos Sistemas de Seguridad para Sitios Web y Apps</h3>
                <ul className="block-list list-none">
                    <li>Estrategizamos continuamente ideas que cumplen con los estándares.</li>
                    <li>Aprovechamos globalmente soluciones alternativas existentes.</li>
                    <li>Alineaciones basadas en rendimiento. Aprovechamos globalmente alternativas.</li>
                </ul>
                <Link className="theme_btn mt-35" to="/project-details">Más Detalles</Link>
            </div>
        </Fragment>
    )
}

export default BlockStyleEight